import React, { useEffect, useState, useRef, createElement, Component } from 'react';
import { CheckCircle2, ChevronRight, ChevronLeft, Star, BookOpen, Target, TrendingUp, Dumbbell, Zap, Gift, Clock, X } from 'lucide-react';
// --- Meta Pixel Setup ---
const PIXEL_ID = '1252242806993118';
const initPixel = () => {
  if (typeof window === 'undefined') return;
  const w = window as any;
  if (w.fbq) {
    try {
      w.fbq('track', 'PageView');
    } catch (e) {}
    return;
  }
  const n: any = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  w.fbq = n;
  if (!w._fbq) w._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  try {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const target = document.head || document.body || document.documentElement;
    if (target) {
      target.appendChild(script);
    }
    w.fbq('init', PIXEL_ID);
    w.fbq('track', 'PageView');
  } catch (e) {
    // Fail silently — pixel is non-critical for page rendering
    console.warn('Meta Pixel failed to initialize:', e);
  }
};
// --- Components ---
const CountdownBar = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    // Check local storage for end time
    const storedEndTime = localStorage.getItem('offerEndTime');
    let endTime: number;
    if (storedEndTime) {
      endTime = parseInt(storedEndTime, 10);
      // If time has passed, reset it to 24 hours from now
      if (Date.now() > endTime) {
        endTime = Date.now() + 24 * 60 * 60 * 1000;
        localStorage.setItem('offerEndTime', endTime.toString());
      }
    } else {
      endTime = Date.now() + 24 * 60 * 60 * 1000;
      localStorage.setItem('offerEndTime', endTime.toString());
    }
    const timer = setInterval(() => {
      const now = Date.now();
      const distance = endTime - now;
      if (distance < 0) {
        clearInterval(timer);
        setTimeLeft({
          hours: 0,
          minutes: 0,
          seconds: 0
        });
        return;
      }
      setTimeLeft({
        hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
        minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(distance % (1000 * 60) / 1000)
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="bg-lime-500 text-zinc-950 py-2 px-4 sticky top-0 z-50 flex justify-center items-center gap-2 text-sm md:text-base font-bold uppercase tracking-wide shadow-[0_0_15px_rgba(163,230,53,0.5)]" data-id="element-1">
      <Clock className="w-4 h-4 md:w-5 md:h-5 animate-pulse" data-id="element-2" />
      <span data-id="element-3">Oferta termina en:</span>
      <span className="font-sans font-black tabular-nums bg-zinc-950 text-lime-500 px-2 py-0.5 rounded" data-id="element-4">
        {formatTime(timeLeft.hours)}:{formatTime(timeLeft.minutes)}:
        {formatTime(timeLeft.seconds)}
      </span>
    </div>;
};
const PurchasePopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [purchaseData, setPurchaseData] = useState({
    name: '',
    city: '',
    time: ''
  });
  const names = ['Martín', 'Camila', 'Lucas', 'Sofía', 'Diego', 'Valentina', 'Mateo', 'Florencia', 'Joaquín', 'Agustina'];
  const cities = ['Córdoba', 'Rosario', 'Buenos Aires', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Neuquén', 'Santa Fe'];
  const times = ['hace 2 minutos', 'hace 5 minutos', 'hace 12 minutos', 'hace 1 hora', 'hace 30 minutos'];
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = times[Math.floor(Math.random() * times.length)];
      setPurchaseData({
        name: randomName,
        city: randomCity,
        time: randomTime
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Hide after 5 seconds
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(showPopup, 10000);
    // Subsequent popups every 25-45 seconds
    const intervalTimer = setInterval(() => {
      if (!isVisible) {
        setTimeout(showPopup, Math.random() * 20000 + 25000);
      }
    }, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, [isVisible]);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 bg-zinc-900 border border-zinc-800 rounded-lg p-4 shadow-2xl flex items-start gap-4 max-w-sm animate-in slide-in-from-bottom-5 fade-in duration-300" data-id="element-5">
      <div className="bg-lime-500/20 p-2 rounded-full shrink-0" data-id="element-6">
        <CheckCircle2 className="w-6 h-6 text-lime-500" data-id="element-7" />
      </div>
      <div data-id="element-8">
        <p className="text-sm text-zinc-300" data-id="element-9">
          <span className="font-bold text-white" data-id="element-10">{purchaseData.name}</span> de{' '}
          {purchaseData.city}
        </p>
        <p className="text-xs font-bold text-lime-400 mt-0.5" data-id="element-11">
          Compró Dominadas Smart Pro
        </p>
        <p className="text-xs text-zinc-500 mt-1" data-id="element-12">{purchaseData.time}</p>
      </div>
      <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-zinc-500 hover:text-white" data-id="element-13">
        <X className="w-4 h-4" data-id="element-14" />
      </button>
    </div>;
};
const Carousel = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const images = ['https://cdn.magicpatterns.com/uploads/7yhwTiv56PFXphRVLzHLdX/IMG_4809.png', 'https://cdn.magicpatterns.com/uploads/mMgp8uHwJErUmZYeDC1AYP/IMG_4810.png', 'https://cdn.magicpatterns.com/uploads/pDoEQoNbqaDAdQQ8XpX9Zr/IMG_4812.png'];
  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const {
        current
      } = scrollRef;
      const scrollAmount = current.clientWidth;
      if (direction === 'left') {
        current.scrollBy({
          left: -scrollAmount,
          behavior: 'smooth'
        });
      } else {
        current.scrollBy({
          left: scrollAmount,
          behavior: 'smooth'
        });
      }
    }
  };
  const scrollToBuy = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="relative w-full max-w-md mx-auto group" data-id="element-15">
      <div ref={scrollRef} className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide hide-scrollbar aspect-square rounded-2xl border border-zinc-800 bg-zinc-900" style={{
      scrollbarWidth: 'none',
      msOverflowStyle: 'none'
    }} data-id="element-16">
        {images.map((src, index) => <div key={index} className="w-full shrink-0 snap-center flex items-center justify-center p-4 cursor-pointer" onClick={scrollToBuy} data-id="element-17">
            <img src={src} alt={`Contenido del ebook ${index + 1}`} className="w-full h-full object-contain rounded-xl" data-id="element-18" />
          </div>)}
      </div>

      <button onClick={e => {
      e.stopPropagation();
      scroll('left');
    }} className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-lime-500 hover:text-black text-white p-2 rounded-full backdrop-blur-sm transition-colors opacity-0 group-hover:opacity-100 md:opacity-100" data-id="element-19">
        <ChevronLeft className="w-6 h-6" data-id="element-20" />
      </button>
      <button onClick={e => {
      e.stopPropagation();
      scroll('right');
    }} className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-lime-500 hover:text-black text-white p-2 rounded-full backdrop-blur-sm transition-colors opacity-0 group-hover:opacity-100 md:opacity-100" data-id="element-21">
        <ChevronRight className="w-6 h-6" data-id="element-22" />
      </button>

      <div className="flex justify-center gap-2 mt-4" data-id="element-23">
        {images.map((_, i) => <div key={i} className="w-2 h-2 rounded-full bg-zinc-700" data-id="element-24" />)}
      </div>
      <style dangerouslySetInnerHTML={{
      __html: `
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
      `
    }} data-id="element-25" />
    </div>;
};
export function LandingPage() {
  useEffect(() => {
    initPixel();
  }, []);
  const scrollToBuy = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const buyLink = 'https://checkout.ebookpoint.shop/cart/59526388842577:1';
  return <div className="min-h-screen bg-zinc-950 text-zinc-100 font-sans selection:bg-lime-500 selection:text-zinc-950 pb-20" data-id="element-26">
      <CountdownBar data-id="element-27" />
      <PurchasePopup data-id="element-28" />

      {/* HERO SECTION */}
      <section className="pt-12 pb-16 px-4 max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-29">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold uppercase leading-[1.15] tracking-wide mb-8 text-white drop-shadow-lg max-w-3xl" style={{
        wordSpacing: '0.08em'
      }} data-id="element-30">
          Construí fuerza <span className="text-lime-500" data-id="element-31">REAL</span> y pasa de
          usar banda a elastica a tu primera dominada
        </h1>

        <div className="relative w-full max-w-[260px] mx-auto mb-8 cursor-pointer group" onClick={scrollToBuy} data-id="element-32">
          <div className="absolute inset-0 bg-lime-500/20 blur-3xl rounded-full group-hover:bg-lime-500/30 transition-colors duration-500" data-id="element-33"></div>
          <img src="https://cdn.magicpatterns.com/uploads/2YaR427eUPTwEcvkFVaJwk/ChatGPT_Image_May_16,_2026,_09_57_34_PM.png" alt="Dominadas Smart Pro Bundle" className="relative z-10 w-full h-auto drop-shadow-2xl transform group-hover:scale-105 transition-transform duration-500" data-id="element-34" />
        </div>

        <p className="text-lg md:text-xl text-zinc-300 max-w-2xl mx-auto mb-10 font-medium leading-relaxed" data-id="element-35">
          El sistema definitivo en 5 capitulos para hombres y mujeres que
          quieren conquistar la barra — sin importar si arrancás desde cero o
          estás estancado.
        </p>

        <button onClick={scrollToBuy} className="w-full max-w-md bg-lime-500 hover:bg-lime-400 text-zinc-950 font-black text-xl py-5 px-8 rounded-xl uppercase tracking-wider shadow-[0_0_30px_rgba(163,230,53,0.3)] hover:shadow-[0_0_40px_rgba(163,230,53,0.5)] transition-all transform hover:-translate-y-1 flex items-center justify-center gap-3" data-id="element-36">
          QUIERO MI PRIMERA DOMINADA <ChevronRight className="w-6 h-6" data-id="element-37" />
        </button>
      </section>

      {/* PAIN POINTS */}
      <section className="py-16 px-4 bg-zinc-900/50 border-y border-zinc-800" data-id="element-38">
        <div className="max-w-3xl mx-auto" data-id="element-39">
          <h2 className="text-3xl md:text-5xl text-center mb-12 text-white" data-id="element-40">
            ¿Por qué seguís sin poder hacer una dominada?
          </h2>
          <div className="grid gap-6 md:grid-cols-2" data-id="element-41">
            {['Entrenás sin un plan claro ni progresión lógica.', 'Técnica deficiente que te hace perder fuerza.', 'Falta de volumen acumulado de calidad.', 'Frustración por estancamiento constante.'].map((pain, i) => <div key={i} className="flex items-start gap-4 bg-zinc-900 p-6 rounded-2xl border border-zinc-800" data-id="element-42">
                <div className="bg-red-500/10 p-2 rounded-lg shrink-0" data-id="element-43">
                  <X className="w-6 h-6 text-red-500" data-id="element-44" />
                </div>
                <p className="text-zinc-300 font-medium text-lg" data-id="element-45">{pain}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* CAROUSEL SECTION */}
      <section className="py-20 px-4" data-id="element-46">
        <div className="max-w-4xl mx-auto text-center" data-id="element-47">
          <h2 className="text-4xl md:text-5xl mb-12 text-white" data-id="element-48">
            Un vistazo del sistema Smart Pro
          </h2>
          <Carousel data-id="element-49" />
        </div>
      </section>

      {/* TOMOS SECTION */}
      <section className="py-16 px-4 bg-zinc-900/30" data-id="element-50">
        <div className="max-w-3xl mx-auto" data-id="element-51">
          <h2 className="text-4xl md:text-5xl text-center mb-12 text-white" data-id="element-52">
            El Sistema Paso a Paso
          </h2>
          <div className="space-y-4" data-id="element-53">
            {[{
            num: 1,
            title: 'La Base: Por Qué No Te Sale la Dominada',
            desc: 'Diagnóstico de errores comunes y fundamentos de fuerza.',
            icon: Target
          }, {
            num: 2,
            title: 'Técnica Precisa: La Dominada Perfecta Paso a Paso',
            desc: 'Alineación, agarre, activación escapular y recorrido.',
            icon: BookOpen
          }, {
            num: 3,
            title: 'De 0 a Tu Primera Dominada',
            desc: 'Progresiones exactas para desbloquear tu primera repetición.',
            icon: Zap
          }, {
            num: 4,
            title: 'De 1 a 5 Dominadas: Construcción de Volumen Real',
            desc: 'Métodos para multiplicar tus repeticiones sin fatigarte.',
            icon: TrendingUp
          }, {
            num: 5,
            title: 'De 5 a +10 Dominadas: Progresión Avanzada de 12 a 14 Semanas',
            desc: 'El plan definitivo para dominar la barra por completo.',
            icon: Dumbbell
          }].map((tomo, i) => <div key={i} className="bg-zinc-900 border border-zinc-800 p-6 rounded-2xl flex flex-col sm:flex-row items-start sm:items-center gap-6 hover:border-lime-500/50 transition-colors" data-id="element-54">
                <div className="bg-lime-500 text-zinc-950 font-black text-2xl w-16 h-16 rounded-xl flex items-center justify-center shrink-0 shadow-[0_0_15px_rgba(163,230,53,0.3)]" data-id="element-55">
                  T{tomo.num}
                </div>
                <div className="flex-1" data-id="element-56">
                  <h3 className="text-2xl text-white mb-2" data-id="element-57">{tomo.title}</h3>
                  <p className="text-zinc-400" data-id="element-58">{tomo.desc}</p>
                </div>
                <tomo.icon className="w-8 h-8 text-zinc-700 hidden sm:block" data-id="element-59" />
              </div>)}
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-20 px-4" data-id="element-60">
        <div className="max-w-5xl mx-auto" data-id="element-61">
          <h2 className="text-4xl md:text-5xl text-center mb-12 text-white" data-id="element-62">
            Resultados Reales
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-63">
            {[{
            name: 'Martín G.',
            age: 28,
            city: 'Córdoba',
            quote: 'Llevaba 2 años sin lograr una dominada. Con el sistema, a las 6 semanas hice 3 seguidas. Una locura, hermano.'
          }, {
            name: 'Camila R.',
            age: 24,
            city: 'Rosario',
            quote: 'Pensé que las dominadas eran para hombres. Hoy hago 4 limpias. El plan para mujeres es un golazo.'
          }, {
            name: 'Lucas F.',
            age: 35,
            city: 'Buenos Aires',
            quote: 'A los 35 creí que ya no iba a poder. Pasé de 0 a 8 dominadas en 3 meses. Recomendadísimo.'
          }, {
            name: 'Sofía M.',
            age: 19,
            city: 'Mendoza',
            quote: 'Soy iniciante total. Con la rutina express del parque entrené sin ir al gym. Hice mi primera dominada en 7 semanas.'
          }, {
            name: 'Diego P.',
            age: 42,
            city: 'La Plata',
            quote: 'Después de los 40 pensé que era imposible. Hoy hago 12 dominadas. Esto te cambia.'
          }].map((test, i) => <div key={i} className="bg-zinc-900 border border-zinc-800 p-6 rounded-2xl flex flex-col justify-between" data-id="element-64">
                <div data-id="element-65">
                  <div className="flex gap-1 mb-4" data-id="element-66">
                    {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-lime-500 text-lime-500" data-id="element-67" />)}
                  </div>
                  <p className="text-zinc-300 italic mb-6" data-id="element-68">"{test.quote}"</p>
                </div>
                <div className="flex items-center gap-3 border-t border-zinc-800 pt-4" data-id="element-69">
                  <div className="w-10 h-10 rounded-full bg-zinc-800 flex items-center justify-center font-bold text-lime-500" data-id="element-70">
                    {test.name.charAt(0)}
                  </div>
                  <div data-id="element-71">
                    <p className="font-bold text-white text-sm" data-id="element-72">
                      {test.name}, {test.age}
                    </p>
                    <p className="text-xs text-zinc-500" data-id="element-73">{test.city}</p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* BONUSES */}
      <section className="py-16 px-4 bg-lime-500/5 border-y border-lime-500/20 relative overflow-hidden" data-id="element-74">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-md h-full bg-lime-500/10 blur-[100px] -z-10" data-id="element-75"></div>
        <div className="max-w-4xl mx-auto" data-id="element-76">
          <div className="text-center mb-12" data-id="element-77">
            <div className="inline-flex items-center gap-2 bg-lime-500 text-zinc-950 font-bold px-4 py-1.5 rounded-full text-sm uppercase tracking-wider mb-6" data-id="element-78">
              <Gift className="w-4 h-4" data-id="element-79" /> Solo por hoy
            </div>
            <h2 className="text-4xl md:text-6xl text-white" data-id="element-80">
              🎁 BONOS GRATIS POR HOY
            </h2>
            <p className="text-zinc-400 mt-4 text-lg" data-id="element-81">
              Incluimos estos 4 bonos sin costo adicional con tu compra hoy.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 gap-6" data-id="element-82">
            {[{
            title: 'Plan Imprimible de 12 Semanas'
          }, {
            title: 'Checklist de Técnica Perfecta'
          }, {
            title: 'Tabla de Errores y Correcciones'
          }, {
            title: 'Rutina Express para Parque o Casa'
          }].map((bono, i) => <div key={i} className="bg-zinc-900 border border-zinc-800 p-6 rounded-2xl relative overflow-hidden group" data-id="element-83">
                <div className="absolute top-4 right-4 bg-lime-500 text-zinc-950 text-xs font-black px-2 py-1 rounded uppercase" data-id="element-84">
                  GRATIS HOY
                </div>
                <h3 className="text-xl text-white mb-2 pr-20 font-sans font-bold" data-id="element-85">
                  Bono {i + 1}:<br data-id="element-86" />
                  {bono.title}
                </h3>
                <div className="flex items-center gap-2 mt-4" data-id="element-87">
                  <span className="text-zinc-500 line-through text-sm" data-id="element-88">
                    Valor: $4.990
                  </span>
                  <span className="text-lime-500 font-bold" data-id="element-89">$0</span>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* BUY SECTION */}
      <section id="comprar" className="py-24 px-4 relative" data-id="element-90">
        <div className="max-w-2xl mx-auto bg-zinc-900 border-2 border-lime-500 rounded-3xl p-8 md:p-12 text-center shadow-[0_0_50px_rgba(163,230,53,0.15)] relative overflow-hidden" data-id="element-91">
          <div className="absolute top-0 left-0 w-full h-2 bg-lime-500" data-id="element-92"></div>

          <h2 className="text-4xl md:text-5xl text-white mb-8" data-id="element-93">
            Empezá Hoy Tu Camino a Tu Primera Dominada
          </h2>

          <div className="bg-zinc-950 rounded-xl p-6 mb-8 border border-zinc-800 text-left" data-id="element-94">
            <h3 className="text-xl text-white mb-4 text-center font-sans font-bold" data-id="element-95">
              ¿Qué te llevás hoy?
            </h3>
            <ul className="space-y-3" data-id="element-96">
              <li className="flex items-center gap-3 text-zinc-300" data-id="element-97">
                <CheckCircle2 className="w-5 h-5 text-lime-500 shrink-0" data-id="element-98" />
                <span data-id="element-99">Sistema Dominadas Smart Pro (5 Tomos)</span>
              </li>
              <li className="flex items-center gap-3 text-zinc-300" data-id="element-100">
                <CheckCircle2 className="w-5 h-5 text-lime-500 shrink-0" data-id="element-101" />
                <span data-id="element-102">
                  <strong className="text-white" data-id="element-103">BONO 1:</strong> Plan
                  Imprimible 12 Semanas
                </span>
              </li>
              <li className="flex items-center gap-3 text-zinc-300" data-id="element-104">
                <CheckCircle2 className="w-5 h-5 text-lime-500 shrink-0" data-id="element-105" />
                <span data-id="element-106">
                  <strong className="text-white" data-id="element-107">BONO 2:</strong> Checklist de
                  Técnica
                </span>
              </li>
              <li className="flex items-center gap-3 text-zinc-300" data-id="element-108">
                <CheckCircle2 className="w-5 h-5 text-lime-500 shrink-0" data-id="element-109" />
                <span data-id="element-110">
                  <strong className="text-white" data-id="element-111">BONO 3:</strong> Tabla de
                  Errores
                </span>
              </li>
              <li className="flex items-center gap-3 text-zinc-300" data-id="element-112">
                <CheckCircle2 className="w-5 h-5 text-lime-500 shrink-0" data-id="element-113" />
                <span data-id="element-114">
                  <strong className="text-white" data-id="element-115">BONO 4:</strong> Rutina Express
                </span>
              </li>
            </ul>
          </div>

          <div className="mb-8" data-id="element-116">
            <p className="text-zinc-500 text-xl line-through decoration-red-500 decoration-2 mb-2 font-sans font-bold" data-id="element-117">
              $52.690 ARS
            </p>
            <p className="text-6xl md:text-7xl font-black text-lime-500 mb-4 tracking-tighter" data-id="element-118">
              $19.990 <span className="text-2xl text-lime-500/80" data-id="element-119">ARS</span>
            </p>
            <div className="inline-block bg-lime-500/20 text-lime-400 font-bold px-4 py-2 rounded-full border border-lime-500/30" data-id="element-120">
              AHORRÁS $32.700 (62% OFF)
            </div>
          </div>

          <a href={buyLink} target="_blank" rel="noopener noreferrer" className="block w-full bg-lime-500 hover:bg-lime-400 text-zinc-950 font-black text-2xl py-6 px-8 rounded-xl uppercase tracking-wider shadow-[0_0_30px_rgba(163,230,53,0.4)] hover:shadow-[0_0_50px_rgba(163,230,53,0.6)] transition-all transform hover:-translate-y-1" data-id="element-121">
            QUIERO MI PRIMERA DOMINADA
          </a>

          <div className="mt-5 bg-zinc-950 border border-lime-500/40 rounded-xl p-4 text-left" data-id="element-122">
            <div className="flex items-center gap-2 mb-2" data-id="element-123">
              <Gift className="w-4 h-4 text-lime-500 shrink-0" data-id="element-124" />
              <p className="text-lime-500 font-bold text-sm uppercase tracking-wide font-sans" data-id="element-125">
                Llevate comprando hoy:
              </p>
            </div>
            <ul className="space-y-1.5 text-sm text-zinc-300 font-sans" data-id="element-126">
              <li className="flex items-start gap-2" data-id="element-127">
                <CheckCircle2 className="w-4 h-4 text-lime-500 shrink-0 mt-0.5" data-id="element-128" />
                <span data-id="element-129">Calculadora de proteínas e hidratación</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-130">
                <CheckCircle2 className="w-4 h-4 text-lime-500 shrink-0 mt-0.5" data-id="element-131" />
                <span data-id="element-132">
                  Checklist de suplementos con evidencia científica: cuál tomar
                  y cuál no
                </span>
              </li>
            </ul>
          </div>

          <p className="text-zinc-500 text-sm mt-6 flex items-center justify-center gap-2" data-id="element-133">
            <Lock className="w-4 h-4" data-id="element-134" /> Pago 100% Seguro y Encriptado
          </p>
        </div>
      </section>
    </div>;
}
// Simple Lock icon since it wasn't imported at the top
function Lock(props: React.SVGProps<SVGSVGElement>) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-135">
      <rect width="18" height="11" x="3" y="11" rx="2" ry="2" data-id="element-136" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" data-id="element-137" />
    </svg>;
}